import { Button, Col, Form, Row } from "react-bootstrap"
import { FeedbackButton, IMG, isValidUrl } from "../../Commons/Functions"
import { useState } from "react";

export default function Preferences_Playmat({ gameData, updateProfileField, ...props }) {
    const [color, setColor] = useState(isValidUrl(props.profileData.background) ? "#141b27" : props.profileData.background);

    const handleColorChange = (e) => {
        setColor(e.target.value);
    };

    return (
        <Form.Group className="d-flex flex-column box-container">
            <div className="d-flex flex-column m-0 playmat-selection">
                <div className="d-flex justify-content-between mb-2">
                    <div className="d-flex flex-column text-start">
                        <p className="ms-2 me-4">To ensure that the playmat will look great on your board, try to find a 16:9 image with a resolution of at least 1080p.</p>
                    </div>
                    <div className="position-relative">
                        <div className="position-relative" style={{
                            width: "35vh",
                            height: "15vh",
                            borderRadius: "0.5rem",
                            overflow: "hidden"
                        }}>
                            {isValidUrl(props.profileData.background) ? (
                                <IMG style={{ width: "35vh", height: "15vh", objectFit: "cover", borderRadius: "0.5rem" }} src={props.profileData.background} />
                            ) : (
                                <div
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        backgroundColor: props.profileData.background
                                    }}
                                />
                            )}
                        </div>
                    </div>
                </div>

                <div className="d-flex">
                    <Form.Control
                        type="text"
                        id="background-image"
                        className='w-75'
                        defaultValue={props.profileData.background}
                    />
                    <FeedbackButton className="w-25" onClick={() => {
                        let val = document.getElementById("background-image").value
                        updateProfileField("background", val)
                    }} feedBack="Changed !">Change</FeedbackButton>
                </div>

                <h5 className="text-start mt-4">Default playmats for {gameData.name}</h5>
                <Row className="me-0">
                    {gameData.defaultRessources && gameData.defaultRessources.backgrounds && gameData.defaultRessources.backgrounds.map((image, i) => {
                        return (<Col xs="6" key={image}>
                            <div className="position-relative playmat-selection-wrapper">
                                <IMG src={image} className="w-100 preference-default-image" onClick={() => {
                                    updateProfileField("background", image)
                                }} />
                            </div>
                        </Col>)
                    })}
                    <Col xs="6" key="color">
                        <div className="position-relative w-100 preference-default-color" style={{ backgroundColor: color }}>
                            <div className="d-flex position-absolute top-50 start-50 translate-middle color-select-wrapper">
                                <Form.Control
                                    type="color"
                                    id="exampleColorInput"
                                    value={color}
                                    onChange={handleColorChange}
                                    title="Choose your color"
                                    className="m-1"
                                />
                                <Button className="m-1" onClick={() => {
                                    updateProfileField("background", color)
                                }}>Apply color</Button>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </Form.Group>
    )
} 